//获取订单列表(买家)
export const GET_ORDER_LIST = "GET_ORDER_LIST";
//获取订单详情(买家)
export const GET_ORDER_ITEM = "GET_ORDER_ITEM";
//设置订单详情(买家)
export const SET_ORDER_ITEM = "SET_ORDER_ITEM";
//取消订单
export const CANCEL_ORDER = "CANCEL_ORDER";
//获取取消订单原因
export const GET_CANCEL_ORDER_REASON = "GET_CANCEL_ORDER_REASON";
//获取取消订单流程文案
export const GET_CANCEL_ORDER_NODE = "GET_CANCEL_ORDER_NODE";
//支付
export const GO_PAY = "GO_PAY";
//设置选中的订单tab类型
export const SET_TAB_STATUS = "SET_TAB_STATUS";
//获取物流详情
export const GET_LOGISTIC = "GET_LOGISTIC";
//设置物流详情
export const SET_LOGISTIC = "SET_LOGISTIC";

//获取订单列表(卖家)
export const GET_SELLER_ORDER_LIST = "GET_SELLER_ORDER_LIST";
//获取订单详情(卖家)
export const GET_SELLER_ORDER_ITEM = "GET_SELLER_ORDER_ITEM";
//获取快递公司信息
export const GET_EXPRESS_COMPANIES = "GET_EXPRESS_COMPANIES";
//设置快递公司信息
export const SET_EXPRESS_COMPANIES = "SET_EXPRESS_COMPANIES";
//出库
export const ORDER_SHIPPING = "ORDER_SHIPPING";
//确认收货
export const CONFIRMDELIVERY = "CONFIRMDELIVERY";
//三方卖家导出订单
export const SELLER_EXPORT_ORDER = "SELLER_EXPORT_ORDER";
//确认是否使用物权转移
export const ORDER_IS_USE_WUQUAN = "ORDER_IS_USE_WUQUAN";
//确认配送物权转移订单
export const CONFIRM_DELIVERY_WUQUAN_ORDER = "CONFIRM_DELIVERY_WUQUAN_ORDER";

//获取卖家是否开通上门取件
export const GET_PICK_STATUS = "GET_PICK_STATUS";
//设置卖家是否开通上门取件
export const SET_PICK_STATUS = "SET_PICK_STATUS";

//开通上门取件
export const OPEN_DOOR_PICK = "OPEN_DOOR_PICK";

//卖家订单上门取件
export const SELLER_ORDER_DOOR_PICK = "SELLER_ORDER_DOOR_PICK";

//获取开通上门取件的快递类型
export const GET_TRADE_TYPE = "GET_TRADE_TYPE";
//设置开通上门取件的快递类型
export const SET_TRADE_TYPE = "SET_TRADE_TYPE";







// WEBPACK FOOTER //
// ./src/store/my-order/type.js